import type { SlotsManagementStore } from './interfaces'

export const getters = {
  isSaving: (state: SlotsManagementStore): SlotsManagementStore['saving'] => state.saving,
  getDayTabId: (state: SlotsManagementStore): SlotsManagementStore['dayTabId'] => state.dayTabId,
  getBookingDays: (state: SlotsManagementStore): SlotsManagementStore['bookingDays'] => state.bookingDays,
  getSalesQueueDays: (state: SlotsManagementStore): SlotsManagementStore['salesQueueDays'] => state.salesQueueDays,
}
